import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SIRGPD_CRD_CONT;

export default {
  create(payload) {
    return baseApi.post(resource, payload);
  },
};
